import { defineStore } from 'pinia';
import axios from 'axios';

export const useMarketStore = defineStore('market', {
    state: () => ({
        selectedMarket: null,
        selectedProject: 'na',
        markets: [],
        projects: [],
        business_account_id: 0,
        cond_url: null,
        perplexity_enabled: false,
        force_key: new Date().getTime() - 15 * 60 * 1000,
        redirectRoute: null
    }),
    getters: {
        projectName(state) {
            const project = state.projects.find(p => p.id === state.selectedProject);
            return project ? project.name : null;
        },
        marketName(state) {
            const market = state.markets.find(m => m.id === state.selectedMarket);
            return market ? market.name : null;
        },
        marketNameUnderScore(state) {
            return state.marketName ? state.marketName.replace(/[\s-]+/g, '_').toLowerCase() : null;
        },
        on_boarding(state) {
            if (state.selectedProject === 'na') {
                return true;
            }
            else {
                return state.projects.find(p => p.id === state.selectedProject)?.on_boarding || false;
            }
        }
    },
    actions: {
        async fetchData() {
            try {
                const previousProject = this.selectedProject;
                const previousMarket = this.selectedMarket;
                
                const response = await axios.post(
                    'vuejs/get_projects_markets',
                    {
                        project_id: previousProject !== 'na' ? previousProject : undefined,
                    },
                    { withCredentials: true },
                );
                
                if (this.force_key < new Date().getTime() - 0.5 * 1000) {
                    this.projects = response.data.data;
                    
                    let project;
                    
                    if (previousProject && previousProject !== 'na') {
                        project = this.projects.find(p => p.id === previousProject);
                    }
                    
                    if (!project && this.projects.length > 0) {
                        project = this.projects[0];
                        this.selectedProject = project.id;
                    } else if (project) {
                        this.selectedProject = project.id;
                    }
                    
                    this.markets = project ? project.markets : [];
                    
                    const previousMarketItem = this.markets.find(m => m.id === previousMarket);
                    const marketExists = previousMarketItem !== undefined;
                    
                    if (previousMarket && marketExists) {
                        this.selectedMarket = previousMarket;
                    } else if (previousMarket && !marketExists) {
                        this.selectedMarket = null;
                    } else if (this.markets.length > 0) {
                        this.selectedMarket = this.markets[0].id;
                    }
                    
                    if (response.data.detail) {
                        this.business_account_id = response.data.detail.business_accounts_id;
                        this.cond_url = response.data.detail.url;
                        this.perplexity_enabled = Boolean(response.data.detail.perplexity);
                    }
                }
                
                return response.data.data;
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        },
        
        async fetchMarket(project_id) {
            const response = await axios.post(
                'vuejs/get_markets',
                {
                    project_id: project_id,
                },
                { withCredentials: true },
            );
            return response.data.data;
        },
        
        async forceMarketChange(id, name) {
            const response = await axios.post(
                'vuejs/get_market_switch',
                {
                    id: id,
                    name: name,
                },
                { withCredentials: true },
            );
            this.force_key = new Date().getTime();
            this.selectedMarket = response.data.data.market_id;
            this.selectedProject = response.data.data.project_id;
            this.business_account_id = response.data.data.business_account_id;
            let marketsJson = JSON.parse(response.data.data.markets);
            this.markets = marketsJson;
            return response.data.data;
        },
        
        selectMarket(marketId) {
            this.selectedMarket = marketId;
        },
        
        selectProject(projectId) {
            this.selectedProject = projectId;
            this.selectedMarket = null;
        },
    },
    persist: true,
});